export default __webpack_public_path__ + "static/media/crown.50ae334b.jpeg";